import { useLocation } from 'react-router-dom';
import {
  resolveEffectiveTenant,
  useAdminTenantStore,
  type EffectiveTenant,
} from '@app/stores/adminTenantStore';

export interface UseEffectiveTenantResult extends EffectiveTenant {
  homeTenantId: string | null;
  selectedTenantId: string | null;
  isPlatformAdmin: boolean;
  select: (tenantId: string | null) => void;
  clear: () => void;
}

/**
 * React view of the admin tenant context for the CURRENT route (Phase 51 D-01/D-02).
 *
 * `effectiveTenantId` is the tenant requests on this page work in: the platform_admin's selection
 * on an `/admin` page, the home tenant everywhere else. Must be used inside a Router.
 */
export function useEffectiveTenant(): UseEffectiveTenantResult {
  const { pathname } = useLocation();
  const selectedTenantId = useAdminTenantStore((s) => s.selectedTenantId);
  const homeTenantId = useAdminTenantStore((s) => s.homeTenantId);
  const isPlatformAdmin = useAdminTenantStore((s) => s.isPlatformAdmin);
  const select = useAdminTenantStore((s) => s.select);
  const clear = useAdminTenantStore((s) => s.clear);

  const effective = resolveEffectiveTenant({ pathname, homeTenantId, selectedTenantId, isPlatformAdmin });
  return { ...effective, homeTenantId, selectedTenantId, isPlatformAdmin, select, clear };
}
